import { Component } from '@angular/core';
import { MedrecordIcon } from '../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-chevron-left',
  templateUrl: './chevron-left.component.svg',
})
export class ChevronLeftComponent extends MedrecordIcon {
  viewHeight = 14;
  viewWidth = 8;
}
